<div class="warning-dialog authentication-container d-block e-quote-signup">
  <h2 class="improved-page-label" *ngIf="!isLoginForm">Sign Up</h2>
  <h2 class="improved-page-label" *ngIf="isLoginForm">Sign In</h2>
  <p class="mb-3 warning-note" *ngIf="!isLoginForm">
    If you close this window, your quote will be lost. Kindly continue the
     <span class="hightlighted-note">quoting process or consider creating an account</span></p>
  <form class="custom-form" [formGroup]="signUpForm" *ngIf="!isLoginForm">
    <!-------------------- input for name ---------------------->
    <div class="form-control-box bottom-spacing">
        <label for="name" class="full-name">Full Name<span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="name" placeholder="Enter Full Name"
            formControlName="name"  autocomplete="off">
            <div class="error-message-alignment">
            <div class="improved-error-message email-error-message"
                *ngIf="hasError(signUpForm, 'name', 'required')">
                Full Name is required!
            </div>
            </div>
    </div>
    <!----------------------- input for email---------------------->
    <div class="form-control-box bottom-spacing">
        <label for="email" class="email">Email<span class="text-danger">*</span></label>
        <input type="email" class="form-control" id="email" placeholder="Enter Email"
            formControlName="email" [readonly]="emailVerifed" autocomplete="off">
            <div class="error-message-verify-button-alignment mb-2">
                <div class="error-message-alignment">
                    <div class="error-message error-message-2"
                        *ngIf="hasError(signUpForm, 'email', 'required')">
                        Email Address is required!
                    </div>
                    <div class="error-message error-message-2"
                        *ngIf="hasError(signUpForm, 'email', 'email') || hasError(signUpForm, 'email', 'pattern')">
                        You entered an invalid Email Address!
                    </div>
                </div>
                <!-- <div class="input-details-box justify-content-end">
                    <button type="button" name="verify-email-id-button" id="verify-email-id-button"
                        class="btn btn-verify my-2" (click)="VerifyEmailModel(verifyEmail)"
                        [ngClass]="{'btn-verified': emailVerifed}" [disabled]="emailVerifed || !signUpForm.value.email">{{emailVerifed == true ?
                        'Verified' : 'Verify'}}
                    </button>
                </div> -->
            </div>
    </div>

    <!------------------------ input for phone number ----------------------->
    <div class="form-control-box bottom-spacing ">
        <label for="phone" name="company-phone-number-label" class="label">
            Phone Number
            <span name="company-phone-number-text-danger"
                class="text-danger">*</span>
        </label>
        <ngx-intl-tel-input [cssClass]="'custom'" name="input-field-company-phone-number"
            id="input-field-company-phone-number" class="custom-country-phone-code-dropdown input"
            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true" [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="maxLength"
            [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.International"
            formControlName="phone" ngDefaultControl (paste)="(false)"
            (copy)="false">
        </ngx-intl-tel-input>
        <div class="error-message-verify-button-alignment mb-2">
            <div class="error-message-alignment">
                <mat-error class="error-message error-message-2"
                    *ngIf="hasError(signUpForm, 'phone', 'required')">
                    Phone Number is required
                </mat-error>
                <mat-error class="error-message error-message-2"
                    *ngIf="signUpForm.controls['phone'].invalid && !hasError(signUpForm, 'phone', 'required')">
                    Phone number format is invalid
                </mat-error>
            </div>
            <!-- <div class="input-details-box">
                <button type="button" name="verify-phone-num-button" id="verify-phone-num-button"
                    class="btn btn-verify my-2"
                    (click)="VerifyPhoneModel(verifyPhoneNumber)" [ngClass]="{'btn-verified': phoneVerifed}" [disabled]="phoneVerifed || !signUpForm.value.phone">
                    {{phoneVerifed == true ? 'Verified' : 'Verify'}}
                </button>
            </div> -->
        </div>
    </div>
    
    <!----------------------- input for password ---------------------->
    <div class="form-control-box bottom-spacing field-with-icon">
            <label for="password">Password<span class="text-danger">*</span></label>
            <input [type]="hidePassword ? 'password' : 'text'" class="form-control" id="password"
                placeholder="Enter Password" formControlName="password" (input)="comparePassword()">
            <button type="button" class="icon-btn" (click)="hidePassword = !hidePassword">
                <img [src]="hidePassword ? getImagePath+'hide-pass.svg' : getImagePath+'open-eye-icon.svg' "
                    alt="eye-icon">
            </button>
            <div class="error-message" *ngIf="signUpForm.controls['password']?.touched || signUpForm.controls['password']?.dirty">
                <ng-container *ngIf="signUpForm.controls['password'].hasError('required'); else checkMinLength">
                    Password is required!
                  </ng-container>
                  
                  <ng-template #checkMinLength>
                    <ng-container *ngIf="signUpForm.controls['password'].hasError('minlength') || signUpForm.controls['password'].hasError('maxlength'); else checkPattern">
                      Must be between 8 - 20 characters.
                    </ng-container>
                  </ng-template>
                  
                  <ng-template #checkPattern>
                    <ng-container *ngIf="signUpForm.controls['password'].hasError('pattern');">
                      No white space allowed.
                    </ng-container>
                  </ng-template>

            </div>
    </div>

    <!------------------------- input for confirm password ----------------------------->
    <div class="form-control-box bottom-spacing field-with-icon mb-3">
            <label for="confirmPassword">Confirm Password<span class="text-danger">*</span></label>
            <input [type]="hideConfirmPassword ? 'password' : 'text'" class="form-control"
                id="confirmPassword" placeholder="Enter Confirm Password" formControlName="confirmPassword"
                (input)="comparePassword()">
            <button type="button" class="icon-btn" (click)="hideConfirmPassword = !hideConfirmPassword">
                <img [src]="hideConfirmPassword ? getImagePath+'hide-pass.svg' : getImagePath+'open-eye-icon.svg'"
                    alt="eye-icon">
            </button>
            <div class="error-message" *ngIf="signUpForm.controls['confirmPassword']?.touched || signUpForm.controls['confirmPassword']?.dirty">
                <ng-container *ngIf="signUpForm.controls['confirmPassword'].hasError('required'); else checkMinLength">
                    Confirm Password is required!
                  </ng-container>
                  
                  <ng-template #checkMinLength>
                    <ng-container *ngIf="signUpForm.controls['confirmPassword'].hasError('minlength') || signUpForm.controls['confirmPassword'].hasError('maxlength'); else checkPattern">
                      Must be between 8 - 20 characters.
                    </ng-container>
                  </ng-template>
                  
                  <ng-template #checkPattern>
                    <ng-container *ngIf="signUpForm.controls['confirmPassword'].hasError('pattern'); else checkSamePassword">
                      No white space allowed.
                    </ng-container>
                  </ng-template>
                  
                  <ng-template #checkSamePassword>
                    <ng-container *ngIf="!isSame">
                        Confirm password does not match with the new password.
                    </ng-container>
                  </ng-template>
            </div>
    </div>

    <!-------------------------- submittion button -------------------------->
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
    <div class="d-flex justify-content-center align-items-center flex-column">
        <button type="submit" (click)="SignUp()" class="btn btn-primary improved-add-btn w-100 mb-2">
            Sign Up
        </button>
        <div class="d-flex justify-content-center align-items-center newuser-gray-text mt-2">
        <span>Already a customer?</span> <a (click)="toggleForm()" style="cursor: pointer;" class="link">Sign-in here</a>
    </div>
    </div>
</form>

<form class="custom-form" [formGroup]="loginForm" *ngIf="isLoginForm">
    <p class="mb-3 warning-note">
        Please sign in to enjoy a personalized experience and manage your quotes.
         </p>
    
  <div class="form-control-box bottom-spacing mt-2">
    <label for="email">Email Address<span class="text-danger">*</span></label>
    <input type="email" class="form-control" id="email" placeholder="Email" formControlName="email">
    <div class="error-message quote-error-message"
      *ngIf="loginForm.controls['email']?.touched && loginForm.controls['email'].hasError('required')">
      Email Address is required!
    </div>
    <div class="error-message"
      *ngIf="loginForm.controls['email']?.touched && loginForm.controls['email']?.hasError('email') || loginForm.controls['email']?.hasError('pattern')">
      You entered an invalid Email Address!
    </div>
  </div>
  <div class="form-control-box bottom-spacing field-with-icon">
      <label for="password">Password<span class="text-danger">*</span></label>
      <input [type]="hidePassword ? 'password' : 'text'" class="form-control" id="password" placeholder="Password"
        formControlName="password">
      <button type="button" class="icon-btn" (click)="hidePassword = !hidePassword">
        <img [src]="hidePassword ? getImagePath+'hide-pass.svg' : getImagePath+'open-eye-icon.svg' "
          alt="eye-icon">
      </button>
    <div class="error-message" *ngIf="loginForm.controls['password']?.touched">
      <ng-container *ngIf="loginForm.controls['password'].hasError('required')">
        Password is required!
      </ng-container>
      <ng-container
        *ngIf="loginForm.controls['password'].hasError('minlength') || loginForm.controls['password'].hasError('maxlength')">
        Must be between 8 - 20 characters.
      </ng-container>
      <ng-container *ngIf="loginForm.controls['password'].hasError('pattern')">
        No white space allowed.
      </ng-container>
    </div>
  </div>
  <div class="loading">
    <button type="submit" class="btn btn-primary improved-add-btn w-100 mb-2 mt-2" (click)="HandleLogin()">
      Login
    </button>
    <div class="d-flex justify-content-center align-items-center newuser-gray-text mt-2">
        <span>Are you a new user?</span> <a (click)="toggleForm()" style="cursor: pointer;" class="link">Sign-Up Here</a>
      </div>
  </div>
</form>
</div>


<ng-template name="verify-phone-num-modal" id="verify-phone-num-modal" #verifyPhoneNumber let-c="close" let-d="dismiss">
  <div name="verify-phone-num-modal-header" id="verify-phone-num-modal-header" class="modal-header">
      <h1 name="verify-phone-num-modal-title" id="verify-phone-num-modal-title" class="modal-title">Phone Number
          Verification</h1>
  </div>
  <div name="verify-phone-num-modal-body" id="verify-phone-num-modal-body" class="modal-body">
      <form name="verifyPhoneNumberForm" id="verifyPhoneNumberForm" class="form" [formGroup]="verifyPhoneNumberForm"
          (ngSubmit)="VerifyPhoneNumber()">
          <p name="verify-phone-num-modal-verification-text" id="verify-phone-num-modal-verification-text"
              class="modal-text mt-3 mb-3">We have sent the verification code to
              <strong>{{verifyPhoneNumberForm.value.vPhoneNo}}.</strong> Please enter the code below.
          </p>
          <div class="">
              <ng-otp-input name="otp-input-verify-phone-num-modal" id="otp-input-verify-phone-num-modal"
                  (onInputChange)="OnPhoneNumberOtpChange($event)" [config]="phoneOtpConfig"></ng-otp-input>
              <mat-error name="mat-error-verify-phone-num-modal" id="mat-error-verify-phone-num-modal"
                  class="text-center pt-2 pb-0" *ngIf="submitted && verifyPhoneNumberForm.controls['iOTP'].errors">
                  <mat-error name="mat-error-verify-phone-num-modal-text-1"
                      id="mat-error-verify-phone-num-modal-text-1"
                      *ngIf="verifyPhoneNumberForm.controls['iOTP'].errors['required']" class="pb-0">
                      OTP is required
                  </mat-error>
                  <mat-error name="mat-error-verify-phone-num-modal-text-2"
                      id="mat-error-verify-phone-num-modal-text-2"
                      *ngIf="verifyPhoneNumberForm.controls['iOTP'].errors['minlength'] || verifyPhoneNumberForm.controls['iOTP'].errors['maxlength']"
                      class="pb-0">
                      Fill all the characters
                  </mat-error>
              </mat-error>
          </div>
          <div name="verify-phone-num-modal-resendtext" id="verify-phone-num-modal-resendtext" class="modal-text top-space d-flex align-items-center justify-content-between ">
              I didn't receive a code. 
              
              <button name="verify-phone-num-modal-resend-button"
                  id="verify-phone-num-modal-resend-button" class="modal-link" type="button"
                  (click)="ResendPhoneOTP()">Resend</button>
          </div>
      </form>
  </div>
  <div name="verify-phone-num-modal-footer" id="verify-phone-num-modal-footer" class="modal-footer">
     
      <button name="verify-phone-num-modal-cancel-button" id="verify-phone-num-modal-cancel-button"
          class="cancel-button" type="button"
          (click)="d('Cross click'); this.verifyEmailForm.reset(); this.submitted = false;">Cancel</button>
          <button name="verify-phone-num-modal-verify-button" id="verify-phone-num-modal-verify-button"
          class="btn btn-primary improved-add-btn" type="submit" form="verifyPhoneNumberForm">Verify</button>
  </div>
</ng-template>

<ng-template name="verify-email-modal" id="verify-email-modal" #verifyEmail let-c="close" let-d="dismiss">
  <div name="verify-email-modal-header" id="verify-email-modal-header" class="modal-header">
      <h1 name="verify-email-modal-title" id="verify-email-modal-title" class="modal-title text-start">Email Verification</h1>
  </div>
  <div name="verify-email-modal-body" id="verify-email-modal-body" class="modal-body verify-email-modal-body">
      <form name="verifyEmailForm" id="verifyEmailForm" class="form" [formGroup]="verifyEmailForm"
          (ngSubmit)="VerifyEmail()">
          <p name="verify-email-modal-verificationtext" id="verify-email-modal-verificationtext" class="modal-text mb-4 mt-3">We
              have
              sent the verification code to <strong>{{verifyEmailForm.value.vEmailId}}.</strong> Please enter the code
              below.
          </p>
          <div class="">
              <ng-otp-input name="otp-input-verify-email-modal" id="otp-input-verify-email-modal"
                  (onInputChange)="OnEmailOtpChange($event)" [config]="emailOtpConfig"></ng-otp-input>
              <mat-error name="mat-error-verify-email-modal" id="mat-error-verify-email-modal"
                  *ngIf="submitted && verifyEmailForm.controls['iOTP'].errors" class="d-flex justify-content-center p-2">
                  <mat-error name="mat-error-verify-email-modal-text-1" id="mat-error-verify-email-modal-text-1" class="d-flex justify-content-center"
                      *ngIf="verifyEmailForm.controls['iOTP'].errors['required']" class="pb-0">
                      OTP is required
                  </mat-error>
                  <mat-error name="mat-error-verify-email-modal-text-2" id="mat-error-verify-email-modal-text-2"
                      class="pb-0"
                      *ngIf="verifyEmailForm.controls['iOTP'].errors['minlength'] || verifyEmailForm.controls['iOTP'].errors['maxlength']">
                      Fill all the characters
                  </mat-error>
              </mat-error>
          </div>
          <div name="verify-email-modal-resendtext" id="verify-email-modal-resendtext" class="modal-text top-space d-flex align-items-center justify-content-between">I
              didn't
              receive a code. 
              <button name="verify-email-modal-resend-button w-100" id="verify-email-modal-resend-button"
          class="modal-link" type="button" (click)="ResendEmailOTP()">Resend</button>
          </div>
      </form>
  </div>
  <div name="verify-email-modal-footer" id="verify-email-modal-footer" class="modal-footer">
    <button type="button" name="verify-email-modal-cancel-button" id="verify-email-modal-cancel-button"
          class="cancel-button me-3"
          (click)="d('Cross click'); this.verifyEmailForm.reset(); this.submitted = false;">Cancel</button>
      <button type="submit" name="verify-email-modal-verify-button" id="verify-email-modal-verify-button"
          class="btn btn-primary improved-add-btn" form="verifyEmailForm">Verify</button>
  </div>
</ng-template>